export default function IconArrowUpRight({ className }: { className?: string }) {
    return (
        <svg
            className={className}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 6V8H22.59L6 24.59L7.41 26L24 9.41V22H26V6H10Z"
                fill="currentColor"
            />
        </svg>
    )
}
